/**
 *
 * Asynchronously loads the component for AnalyticsPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AnalyticsPage = lazyLoad(
  () => import('./index'),
  module => module.AnalyticsPage,
);
